import whenIdle from "@src/helpers/whenIdle";
import { noticeError } from "@src/helpers/monitoring";

const NAVIGATION_INTENT_EVENTS = ["focusin", "touchstart"];
const NAVIGATION_INTENT_LISTENER_OPTIONS = { capture: true, passive: true };
const NAVIGATION_INTENT_IDLE_TIMEOUT_MS = 1000;

const importPersonaliseNavigation = () =>
  import(
    /* webpackChunkName: "dynamic-navigation-personalisation" */
    /* webpackPrefetch: true */
    "./personaliseNavigation"
  ).then(({ personaliseNavigation }) => personaliseNavigation);

const importPersonaliseNavigationWithOneRetry = () =>
  importPersonaliseNavigation().catch(() => importPersonaliseNavigation());

export const schedulePersonalisation = ({ store, navData }) => {
  let hasStarted = false;

  const removeIntentListeners = () =>
    NAVIGATION_INTENT_EVENTS.forEach(eventName =>
      document.removeEventListener(
        eventName,
        handleIntent,
        NAVIGATION_INTENT_LISTENER_OPTIONS
      )
    );

  const start = () => {
    if (hasStarted) {
      return;
    }
    hasStarted = true;

    removeIntentListeners();

    importPersonaliseNavigationWithOneRetry()
      .then(personaliseNavigation => personaliseNavigation({ store, navData }))
      .catch(error => {
        noticeError(error, {
          siteChromeNavigation: "personalisation failed"
        });
      });
  };

  const handleIntent = () => {
    removeIntentListeners();

    whenIdle(start, {
      timeout: NAVIGATION_INTENT_IDLE_TIMEOUT_MS
    });
  };

  NAVIGATION_INTENT_EVENTS.forEach(eventName =>
    document.addEventListener(
      eventName,
      handleIntent,
      NAVIGATION_INTENT_LISTENER_OPTIONS
    )
  );

  whenIdle(start);
};
